// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"523":"742129ec","787":"758f5b63"}[chunkId] + ".chunk.js";
};